import {useContext} from 'react';
import PropTypes from 'prop-types';

import {PageContext} from '@amblique/contentful/app/contexts/contentful';
import {useBazaarvoiceReviewsPresence} from '@amblique/king-living/app/context/bazaarvoice-reviews-presence-context';
import ProductBazaarvoice from '@amblique/king-living/app/components/product-bazaarvoice';

/**
 * Renders {@link ProductBazaarvoice} when no Contentful `BazaarvoiceReviews` module is on
 * the page. Injected by {@link Container} immediately below Product Detail - Dynamic when
 * the CMS entry is missing; also used on OOTB `/product/:id` (no PageContext) via product prop.
 * Skips when CMS module marks presence.
 *
 * Uses `useContext(PageContext)` (not `usePageContext`) so missing provider returns null
 * instead of throwing on standard PDPs.
 *
 * @param {object} props
 * @param {object} [props.product] - SCAPI product (OOTB PDP path; Contentful pages use page context)
 */
export function ProductBazaarvoiceFallback({product: productProp}) {
  const presence = useBazaarvoiceReviewsPresence();
  const pageContext = useContext(PageContext);
  const product = productProp ?? pageContext?.product;

  // CMS module already on the page (same or later Container) — do not duplicate.
  if (presence?.present) {
    return null;
  }

  if (!product) {
    return null;
  }

  return <ProductBazaarvoice product={product} />;
}

ProductBazaarvoiceFallback.propTypes = {
  product: PropTypes.object,
};

export default ProductBazaarvoiceFallback;
